import { render, staticRenderFns } from "./BaseMenuBar.vue?vue&type=template&id=0889ab62&"
import script from "./BaseMenuBar.vue?vue&type=script&lang=js&"
export * from "./BaseMenuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports